import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    }
}));


// const useStyles = makeStyles(() => ({
//     paper: {
//         position: "absolute",
//         // top: "0",
//         // left: "0",
//         width: "100%",
//         height: "100%",
//         backgroundColor: "rgba(0, 0, 0, 0.1)"
//     },
//     image: {
//         position: "relative",
//         top: "50%",
//         left: "50%",
//         marginTop: "-50px",
//         marginLeft: "-50px"
//     }
// }));


export default function LoadingUI() {
    const classes = useStyles();

    return (
        <div className={classes.paper}>
            <img src="/img/logo-fca.gif" alt="" />
        </div>
    );
};